export default function registerAddressAutocomplete(Alpine) {
  Alpine.data("addressAutocomplete", (apiKey) => ({
    loaded: false,
    autocomplete: null,

    init() {
      if (!apiKey) return;
      this.loadGoogleMaps().then(() => this.initAutocomplete());
    },

    loadGoogleMaps() {
      if (window.google?.maps?.places?.Autocomplete) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
        if (!existing) {
          const script = document.createElement("script");
          script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }

        const check = () => {
          if (window.google?.maps?.places?.Autocomplete) {
            resolve();
          } else {
            setTimeout(check, 100);
          }
        };
        check();
      });
    },

    initAutocomplete() {
      const input = this.$refs.streetInput;
      if (!input || !window.google?.maps?.places?.Autocomplete) return;

      this.autocomplete = new window.google.maps.places.Autocomplete(input, {
        types: ["address"],
        fields: ["address_components", "formatted_address"]
      });

      this.autocomplete.addListener("place_changed", () => {
        this.fillAddress(this.autocomplete.getPlace());
      });

      this.loaded = true;
    },

    fillAddress(place) {
      if (!place?.address_components) return;

      let street = "";
      let streetNumber = "";
      let postalCode = "";
      let city = "";
      let country = "";

      for (const component of place.address_components) {
        const type = component.types[0];
        switch (type) {
          case "route":
            street = component.long_name;
            break;
          case "street_number":
            streetNumber = component.long_name;
            break;
          case "postal_code":
            postalCode = component.long_name;
            break;
          case "locality":
          case "postal_town":
            if (!city) city = component.long_name;
            break;
          case "country":
            country = component.long_name;
            break;
        }
      }

      const streetField = document.getElementById("customer_address_street");
      const postalField = document.getElementById("customer_address_postal_code");
      const cityField = document.getElementById("customer_address_city");
      const countryField = document.getElementById("customer_address_country");

      if (streetField) streetField.value = streetNumber ? `${street} ${streetNumber}` : street;
      if (postalField) postalField.value = postalCode;
      if (cityField) cityField.value = city;
      if (countryField) countryField.value = country;
    }
  }));
}
